import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

const BuyXGetYFields = ({ form, setForm }) => {
  const handleChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      config: { ...prev.config, [key]: value },
    }));
  };

  const handleProductTargetChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      appliesTo: {
        ...prev.appliesTo,
        productTargets: [
          {
            ...prev.appliesTo?.productTargets?.[0],
            [key]: value,
          },
        ],
      },
    }));
  };

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Buy Quantity"
          type="number"
          value={form.config.buyQuantity || ""}
          onChange={(e) => handleChange("buyQuantity", Number(e.target.value))}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label="Get Quantity"
          type="number"
          value={form.config.getQuantity || ""}
          onChange={(e) => handleChange("getQuantity", Number(e.target.value))}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Target Product (Product ID)"
          value={form.appliesTo?.productTargets?.[0]?.productId || ""}
          onChange={(e) =>
            handleProductTargetChange("productId", e.target.value)
          }
          helperText="Paste product _id. Product selector to be added later."
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          select
          label="Product Type"
          value={form.appliesTo?.productTargets?.[0]?.productType || ""}
          onChange={(e) =>
            handleProductTargetChange("productType", e.target.value)
          }>
          <MenuItem value="standardCake">Standard Cakes</MenuItem>
          <MenuItem value="specialtyCake">Specialty Cakes</MenuItem>
          <MenuItem value="patisserie">Patisserie</MenuItem>
          <MenuItem value="grazeBox">Graze Boxes</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default BuyXGetYFields;
